// extracted by css-extract-rspack-plugin
export default {"root":"src-components-NodeStatus-NodeStatusIcon-module__root-SYcft4","online":"src-components-NodeStatus-NodeStatusIcon-module__online-euOrZc","alert":"src-components-NodeStatus-NodeStatusIcon-module__alert-PXoSNW","offline":"src-components-NodeStatus-NodeStatusIcon-module__offline-BdZBNu","neutral":"src-components-NodeStatus-NodeStatusIcon-module__neutral-LlAsSD"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-components-NodeStatus-NodeStatusIcon-module__root-SYcft4\",\"online\":\"src-components-NodeStatus-NodeStatusIcon-module__online-euOrZc\",\"alert\":\"src-components-NodeStatus-NodeStatusIcon-module__alert-PXoSNW\",\"offline\":\"src-components-NodeStatus-NodeStatusIcon-module__offline-BdZBNu\",\"neutral\":\"src-components-NodeStatus-NodeStatusIcon-module__neutral-LlAsSD\"}";
        // 1772473573033
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  